import * as React from 'react';
import { observer } from 'mobx-react';
import { IVorgang } from '../../models/ApiTypes';
import SesAuswertungFlaechenRili2025 from './ses/SesAuswertungFlaechenRili2025';
import SesAuswertungFlaechenRili2018 from './ses/SesAuswertungFlaechenRili2018';
import SesAuswertungFlaechenRili2014 from './ses/SesAuswertungFlaechenRili2014';
import { VorgangStore } from '../../stores/VorgangStore';
import { inject } from '../../utils/decorators';

interface IVorlagenBereichProps {
  vorlagenTyp: string;
  vorgang: IVorgang;
}

@observer
export default class VorlagenBereichReadOnly extends React.Component<IVorlagenBereichProps, {}> {
  @inject(VorgangStore) vorgangStore: VorgangStore;
  render() {
    const { vorlagenTyp, vorgang } = this.props;
    switch (vorlagenTyp) {
      case 'ses_auswertung_messwerte':
          return <SesAuswertungFlaechenRili2014 auftragId={this.props.vorgang.anr} vorgangId={vorgang.vorgangguid} editable={false}/>;
        case 'ses_auswertung_messwerte_rili_2018':
          return <SesAuswertungFlaechenRili2018 auftragId={this.props.vorgang.anr} vorgangId={vorgang.vorgangguid} editable={false}/>;
        case 'ses_auswertung_messwerte_rili_2018_2025':
          return <SesAuswertungFlaechenRili2025 auftragId={this.props.vorgang.anr} vorgangId={vorgang.vorgangguid} editable={false}/>;
        default:
        return <div />;
    }
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/VorlagenBereichReadOnly.tsx